import React, { useCallback } from 'react';
import { Stack, Typography } from '@mui/material';
import CustomSwitch from '../../../common/components/CustomSwitch';
import { EPolicyFields } from '../../types/policies-types';
import { updateProfilePolicyProps } from '../../actions/policies-profile-actions/policy-state-actions';
import { updateProfileTotalEnabledPolicies } from '../../actions/profiles-actions/profile-state-actions';
import { enablePoliciesSaveButton } from '../../actions/policies-selection-ui-actions/policies-selection-ui-actions';

interface PolicySwitchButtonProps {
  isPolicySelected: boolean;
  id: string;
}

const PolicySwitchButton: React.FC<
  React.PropsWithChildren<PolicySwitchButtonProps>
> = ({ id, isPolicySelected }) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean): void => {
      event.stopPropagation();
      updateProfileTotalEnabledPolicies(id, checked);
      updateProfilePolicyProps({
        id,
        field: EPolicyFields.selected,
        value: checked,
      });
      enablePoliciesSaveButton(true);
    },
    [id],
  );
  return (
    <Stack direction='row' spacing={1} alignItems='center'>
      <Typography variant='button'>Off</Typography>
      <CustomSwitch onChange={handleChange} checked={isPolicySelected} />
      <Typography variant='button'>On</Typography>
    </Stack>
  );
};

export default PolicySwitchButton;
